import React, { useEffect, useState } from "react";
import { Spinner, Row } from "@masterteam/mt-design-react";
import { getFile, getUserImage } from "../../helpers/attachments";

import AttachmentIcon from "../../assets/images/attachments/attachment.svg";

const AsyncImg = ({ user, file: propFile, fallback, ...props }) => {
  const file = propFile || user;
  const [img, setImg] = useState(fallback || AttachmentIcon);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (file) {
      setIsLoading(true);
      const action = user ? getUserImage : getFile;
      action(file)
        .then(newFile => {
          setImg(newFile.localURL);
        })
        .finally(() => setIsLoading(false));
    }
  }, [file]);

  if (isLoading) {
    return (
      <Row justify="center" align="center" {...props}>
        <Spinner size="small" />
      </Row>
    );
  }

  return (
    <img
      src={img}
      onError={e => {
        e.target.onerror = null;
        setImg(fallback || AttachmentIcon);
      }}
      alt={file?.name || file?.DisplayName}
      {...props}
    />
  );
};

export default AsyncImg;
